import { USER_FIELDS } from '@Clinic/shared/constants/user';
import Form from '@core/forms/base';

export default class NewPasswordForm extends Form {
  setup() {
    return {
      fields: [
        {
          name: USER_FIELDS.newPassword,
          type: 'password',
          rules: 'required|passwordStrength',
        },
        {
          name: USER_FIELDS.newPasswordConfirm,
          type: 'password',
          rules: `required|samePass:${USER_FIELDS.newPassword}`,
        },
      ],
    };
  }
}
